// Set Location Selection Options
const areaOptions = [
	"EAST COAST",
	"GULF COAST",
	"MID-CONTINENT",
	"WEST COAST",
	"WEST TEXAS",
];

// Set Selection Options
const contactClassOptions = [
	"CUSTOMER",
	"RIGCOMPANY",
	"SUPPLIER",
	"DELIVERYASSOC",
];

const statusOptions = ["ACTIVE", "INACTIVE", "PENDING"];

const userStatusOptions = ["ACTIVE", "INACTIVE", "PENDING", "DECLINED"];

const msaStatusOptions = ["ACTIVE", "INACTIVE"];

const firmStatusOptions = ["ACTIVE", "INACTIVE"];

const productStatusOptions = ["ACTIVE", "INACTIVE"];

const firmTypeOptions = ["CUSTOMER", "RIGCOMPANY", "SUPPLIER"];

const accessLevelOptions = ["ADMIN", "GUEST", "STANDARD", "POWER"];

const projectStatusOptions = [
	"ACTIVE",
	"CANCELED",
	"COMPLETED",
	"PENDING",
	"POSTPONED",
];

const requestStatusOptions = [
	"OPEN",
	"NOT-AWARDED",
	"AWARDED-WOA",
	"AWARDED-A",
	"AWARDED-P",
	"IN-PROGRESS",
	"CANCELED",
	"POSTPONED",
	"SSR-REQ",
	"COMPLETED",
];

export {
	areaOptions,
	contactClassOptions,
	statusOptions,
	userStatusOptions,
	accessLevelOptions,
	msaStatusOptions,
	firmStatusOptions,
	firmTypeOptions,
	productStatusOptions,
	projectStatusOptions,
	requestStatusOptions,
};

